module.exports = __webpack_public_path__ + "static/media/A2.7c0ac22f.mp3";